export default (url: string) => {
  const urlParam = new URLSearchParams(url)

  urlParam.delete('&_ga')
  urlParam.delete('&_gac')

  const urlWithoutParam = urlParam.keys().next().value

  const reviewKey = urlWithoutParam.split('/')[5] // review key

  return reviewKey
}
